import { crudRequest } from '@/services/api';
import { message } from 'antd';
import moment from 'moment';

export const TaskType = { Instantly: 1, Timing: 2 }
export const RultType = { FAIL: 0, SUCCESS: 1, ERROR: 2 }
export const TaskStatus = { WAIT: 0, RUNING: 1, SUCCESS: 2, ERROR: 3 }

const defulatState = {
  upFile: null,
  taskType: TaskType.Instantly,
  resultStatus: RultType.ERROR,
  taskTime: moment(new Date()),
  exportVisible: false,
  progressNum: 0,
  taskStatus: TaskStatus.WAIT,
  resultInfo: [],
  taskId: null, // 任务ID
  createdTime: null, // 从服务器获取的任务开始时间,恢复任务时有用
}

export default {
  namespace: 'Importtasks',
  state: { ...defulatState },

  effects: {
    *startTask(_, { call, put, select }) {
      const { upFile, taskType, taskTime } = yield select(({ Importtasks }) => Importtasks)
      if (!(upFile?.uid)) {
        return message.error("你还没有上传数据文件!");
      }
      const param = {
        effectDate: moment(taskTime).format('YYYY-MM-DD HH:mm:ss'),
        fileId: upFile.uid,
        type: taskType
      }
      const data = yield crudRequest(
        '/api/route/trunkLineController/uploadImport',
        param,
        { module: 'basic' }
      );
      if (data && data.code === 1) {
        const taskId = data.data
        yield put({ type: 'updateState', payload: { taskId, progressNum: 1, taskStatus: TaskStatus.RUNING } })
      }
    },
    *repeatTask(_, { call, put, select }){
      const { taskId } = yield select(({ Importtasks }) => Importtasks)
      // 1.执行中  2.成功  3.失败
      // while (result.status === TaskStatus.RUNING) {
      const data = yield crudRequest(
        '/api/route/trunkLineController/getInfoById',
        { id: taskId },
        { reqType: null, module: 'basic' }
      );
      let result = data?.data
      if (result.status === TaskStatus.RUNING) return
      let resultStatus
      switch (result.status) {
        case TaskStatus.ERROR:
          resultStatus = RultType.FAIL
          break;
        case TaskStatus.SUCCESS:
          resultStatus = RultType.SUCCESS
          break;
        default:
          resultStatus = RultType.ERROR
      }
      // 处理不同类型的错误返回结果
      let resultInfo = result.resultInfo ? JSON.parse(result.resultInfo) : []
      if (typeof resultInfo === 'string') {
        resultInfo = [resultInfo]
      }
      yield put({
        type: 'updateState',
        payload: {
          progressNum: 2,
          taskStatus: result.status,
          resultStatus,
          resultInfo
        }
      })
    },
    *isActiveTask(_, { call, put, select }) {
      const data = yield crudRequest(
        '/api/route/trunkLineController/getRuningUpload ', null,
        { reqType: null, module: 'basic' }
      )
      if (data && data.code === 1 && data.data > 0) {
        const taskId = data.data
        const result = yield crudRequest(
          '/api/route/trunkLineController/getInfoById',
          { id: taskId },
          { reqType: null, module: 'basic' }
        );
        yield put({
          type: 'updateState',
          payload: {
            taskId,
            createdTime: moment(result.data?.createdTime),
            progressNum: 1,
            taskStatus: TaskStatus.RUNING
          }
        })
        return true
      }
      return false
    }
  },

  reducers: {
    updateState(state, { payload }) {
      return { ...state, ...payload };
    },
    reSetPram(_, { payload }) {
      return { ...defulatState, ...payload };
    },

  }
}
